<script lang='ts' setup>
import { ref, computed } from 'vue'
import RoomieChipSelector from '@lahaus-roomie/roomie/src/components/RoomieChipSelector/index.vue'

import type { Props } from './types'
import type { UserMessage } from '@/composables/useSamGptCompletions/types'
import { useUserStore } from '@/stores/userStore'
import './_index.scss'

const props = defineProps<Props>()
const emit = defineEmits(['contactMethodSelected'])
const { t } = useI18n()
const userStore = useUserStore()

const contactMethodTypes = computed(() => {
  const methods = [
    {
      id: 'whatsapp',
      label: t('contactMethod.whatsApp')
    },
    {
      id: 'call',
      label: t('contactMethod.call')
    }
  ]

  if (props.is_in_person_visit_active) {
    methods.push({
      id: 'visit',
      label: t('contactMethod.visit')
    })
  } else {
    methods.push({
      id: 'consult',
      label: t('contactMethod.consult')
    })
  }

  return methods
})

const selectedContactMethodIdx = ref<number>()

const handleSelectButton = (idx: number) => {
  selectedContactMethodIdx.value = idx
  const contactMethod = contactMethodTypes.value[idx]
  let userMessage: UserMessage
  if (contactMethod.id === 'visit' || contactMethod.id === 'consult') {
    userMessage = {
      text: `Quiero agendar una ${contactMethod.label.toLocaleLowerCase()}`
    }
  } else {
    userMessage = {
      text: `Quiero que me contacten por ${contactMethod.label.toLocaleLowerCase()}`
    }
  }
  // @ts-ignore
  window.dataLayer?.push({
    event: 'lead-intent-to-contact',
    phone: userStore?.user?.phone,
    screen: 'APP_CHAT_METHOD_SELECTION',
    screen_cta: contactMethod.id
  })

  emit('contactMethodSelected', userMessage)
}
</script>

<script lang='ts'>
export default {
  name: 'AppChatContactMethodSelection'
}
</script>

<template>
  <section class="contact-method-selection contact-method-selection__container app-chat__bubbles app-chat__author-bot">
    <p
      v-if="helperText"
      id="app-chat-contact-method-selection-helper-text"
      class="!mb-0">
      {{ helperText }}
    </p>

    <section>
      <p class="text-12 text-black mb-8 font-medium">
        {{ t('contactMethod.title') }}
      </p>

      <div class="flex flex-row flex-wrap gap-8">
        <RoomieChipSelector
          v-for="contactMethod, idx in contactMethodTypes"
          :id="`app-chat-contact-method-selection-chip-selector-${contactMethod.id}`"
          :key="`app-chat-contact-method-selection-chip-selector-${contactMethod.id}`"
          :data-lh-id="`app-chat-contact-method-selection-chip-selector-${contactMethod.id}`"
          class="app-chat-contact-method-selection__chip-selector"
          :is-selected="selectedContactMethodIdx === idx"
          @click="handleSelectButton(idx)">
          <template #content>
            <p class="text-14 pointer-events-none">
              {{ contactMethod.label }}
            </p>
          </template>
        </RoomieChipSelector>
      </div>
    </section>
  </section>
</template>

<i18n src="./i18n.json" lang="json" />
